import { Component, Input } from '@angular/core';
import { PersonCertificationWrite } from 'src/app/people/models/personCertificationWrite';
import { isWithinCalendarDateRange } from 'src/app/shared/utils/calendar-date.util';

@Component({
  selector: 'certification-snapshot',
  templateUrl: './certification-snapshot.component.html',
  styleUrls: ['./certification-snapshot.component.scss'],
  standalone: false
})
export class CertificationSnapshotComponent {
  @Input()
  certification: PersonCertificationWrite;

  get isActive(): boolean {
    if (!this.certification) return false;

    return isWithinCalendarDateRange(
      this.certification.activeDate,
      this.certification.expirationDate
    );
  }
}
